import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import { MarketingTags } from 'typings'
import { MultiInput, MultiInputClientValidator } from '../../MultiInput'
import { validationSuite } from './validation'

type Props = {
  name: string
  state: FormState
}

type Tags = MarketingTags['tags']

export function MarketingTagsSelector(props: Props) {
  const { name, state } = props

  const intl = useIntl()

  const values: Tags = useWatch({ form: state, name })

  const validation = useMemo(() => validationSuite(name, intl), [intl, name])

  const restrictsBlankSpaces: MultiInputClientValidator = (input: string) => {
    const validationResult = validation(input)

    return validationResult.isValid()
      ? { valid: true }
      : { valid: false, message: validationResult.errors[0].message as string }
  }

  return (
    <MultiInput
      name={name}
      label=""
      values={values}
      onChange={(tags: Tags) => state.setValue(name, tags)}
      maxEntries={LIMITS.MAX_MARKETING_TAGS}
      inputValidation={restrictsBlankSpaces}
    />
  )
}
